import React, { useEffect, useState } from "react";
import NewWindow from "react-new-window";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

import {
  Button,
  Checkbox,
  Collapse,
  Dialog,
  FormControlLabel,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import ActionColumn from "./ActionColumn";
import "./AssignmentDetails.css";
import ModalHistory from "../Chat/ModalHistory";
import ModalTranscription from "../Chat/ModalTranscription";
import NewChat from "../Chat/NewChat";
// import NewChatCampaign from "../Chat/NewChatCampaign";
import Loader from "../Components/Loader";
import VerificationField from "../Components/VerificationField";
import AddEditContactDialog from "../Contact/AddEditContactDialog";
import ContactInformation from "../Contact/ContactInformation";
import formatSecondsToDuration from "../Helper/formatSecondsToDuration";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import { ReactComponent as LiveChatOngoingIcon } from "../Images/LiveChatOngoing.svg";
import QAForm from "../QA/QAForm";
import QAFormTSS from "../QA/QAFormTSS";
import { stateAction } from "../Store/Actions/AuthAction";
import { sendChat } from "../Store/Actions/ChatAction";

import {
  cancelApplication,
  getApplicationDetail,
  getContactVerification,
  getDetailAssignment,
  getDetailAssignmentTSS,
  getForm,
  saveForm,
  submitApplication,
} from "../Store/Actions/OutboundAction";

import {
  GET_NEXT_ASSIGNMENT,
  SET_AUTO_DIAL,
  SET_CALL_SCHEDULE_ASSIGNMENT_ID,
  SET_DIAL_MODE,
  SET_PENDING_STATUS_REASON,
  SET_AGENT_SELECTED_ASSIGNMENT,
  SET_ASSIGNMENT_CHAT_LIST_ID,
} from "../Store/Types/AgentTypes";

import { SET_GO_TO_ACW } from "../Store/Types/CallTypes";

/* const dummyApplication = [
  {
    id: 0,
    submitTime: "2023-03-16T17:01:24.407Z",
    applicationType: "DEFINITE PROTECTION",
    status: "VERIFIED_SELLING",
    createdOn: "2023-03-16T17:01:24.407Z",
  },

  {
    id: 1,
    submitTime: "2023-03-16T17:01:24.407Z",
    applicationType: "DEFINITE PROTECTION",
    status: "REJECTED_QA",
    createdOn: "2023-03-16T17:01:24.407Z",
  },
]; */

/* const dummyApplicationDetail = {
  "Application Type": "SAFE MEDICAL PLAN PLUS",
  "Created Time": "03/03/2023",
  "Estimated Value": "165.000",
  Status: "VERIFIED_SELLING",
  "Bill Freq": "MONTHLY",
  "Submit Time": "03/03/2023",
  NOS: 1,
  "Task Group": "ADMIN",
}; */

const applicationVerificationFields = [
  {
    label: "DOB",
    inputParam: "DOB",
  },

  {
    label: "Emboss kartu",
    inputParam: "EmbossKartu",
  },

  {
    label: "Nomor kartu",
    inputParam: "NomorKartu",
  },

  {
    label: "Mobile no",
    inputParam: "MobileNumber",
  },

  {
    label: "Nama lengkap",
    inputParam: "NamaLengkap",
  },

  {
    label: "Nama ibu kandung",
    inputParam: "NamaIbuKandung",
  },

  {
    label: "Home no",
    inputParam: "HomeNumber",
  },

  {
    label: "Office no",
    inputParam: "OfficeNumber",
  },
];

/* const dummyStatusLog = [
  {
    id: 0,
    submitTime: "2023-03-16T17:01:24.407Z",
    byAgents: "QA_BUDI",

    comments:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam scelerisque rhoncus nisl, a convallis nulla maximus sit amet. Curabitur pellentesque turpis vitae enim malesuada, quis hendrerit mi lobortis. Sed eget tincidunt nunc, ac laoreet sem. Sed ut commodo enim. Suspendisse suscipit quis nibh eget laoreet. Morbi sit amet accumsan felis, ac feugiat odio. Curabitur ornare elit nunc, ut lacinia nisl cursus vel. Cras cursus diam at neque mollis, vel ullamcorper enim porttitor.",
  },

  {
    id: 1,
    submitTime: "2023-03-16T17:01:24.407Z",
    byAgents: "QA_BUDI",
    comments: "Lorem ipsum ...",
  },
]; */

export default function AssignmentDetails({
  assignmentID,
  setSelectedAssignment,
  GenerateNonPopUpFiles,
  isTelemarketing,
  acwMode,
  acwDuration,
  changePage,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [contactInfo, setContactInfo] = useState([]);
  const [contactDetails, setContactDetails] = useState([]);
  const [isContactInfoCollapsed, setIsContactInfoCollapsed] = useState(true);

  const [isContactDetailsCollapsed, setIsContactDetailsCollapsed] =
    useState(true);

  const [isApplicationCollapsed, setIsApplicationCollapsed] = useState(true);

  const [isApplicationFormDetailShown, setIsApplicationFormDetailShown] =
    useState(false);

  const [isApplicationLoading, setIsApplicationLoading] = useState(false);
  const [applicationDetails, setApplicationDetails] = useState(null);

  const [isApplicationVerificationShown, setIsApplicationVerificationShown] =
    useState(false);

  const [isActionLogCollapsed, setIsActionLogCollapsed] = useState(true);
  const [isCustomTableCollapsed, setIsCustomTableCollapsed] = useState(true);

  const [isAddEditContactDialogShown, setIsAddEditContactDialogShown] =
    useState(false);

  const [isModalHistoryShown, setIsModalHistoryShown] = useState(false);
  const [isModalTranscriptionShown, setIsModalTranscriptionShown] = useState(false)
  const [prefix, setPrefix] = useState("");
  const [selectedChatListID, setSelectedChatListID] = useState(null);
  const [selectedWAID, setSelectedWAID] = useState(null);
  const [selectedTranscription, setSelectedTranscription] = useState("");
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [isQAFormDialogShown, setIsQAFormDialogShown] = useState(false);
  const [isVisitHistoryCollapsed, setIsVisitHistoryCollapsed] = useState(true);
  const [visitHistory, setVisitHistory] = useState([]);
  const [detailTSS, setDetailTSS] = useState(null);
  const [selectedApplicationForm, setSelectedApplicationForm] = useState("");
  const [verifiedFields, setVerifiedFields] = useState(0);

  const [isVerificationFieldsLocked, setIsVerificationFieldsLocked] =
    useState(true);

  const [isLoadingVerificationValues, setIsLoadingVerificationValues] =
    useState(false);

  const [submittedValues, setSubmittedValues] = useState(null);

  const initialApplicationModel = {
    recordid: 0,
    datatableid: null,
    datauploadid: null,
    status: null,
    lastupdate: null,
    verif_dob: null,
    verif_embosskartu: null,
    verif_nomorkartu: null,
    verif_namaibukandung: null,
    verif_mobilenumber: null,
    verif_namalengkap: null,
    verif_homenumber: null,
    verif_officenumber: null,
    attempt_dob: null,
    attempt_embosskartu: null,
    attempt_namaibukandung: null,
    attempt_mobilenumber: null,
    attempt_namalengkap: null,
    attempt_homenumber: null,
    attempt_officenumber: null,
    verifok: null,
    namapenerimadana: null,
    norekening: null,
    kotacabang: null,
    lop1_bunga: null,
    lop1_tenor: null,
    lop1_pinjaman: null,
    lop1_cicilan: null,
    lop1_admin: null,
    lop1_promo: null,
    lop2_bunga: null,
    lop2_tenor: null,
    lop2_pinjaman: null,
    lop2_cicilan: null,
    lop2_admin: null,
    lop2_promo: null,
    segment: null,
    account_sts: null,
    hp: null,
    cycle: null,
    lop_type: null,
    program_faf: null,
    program_special_rate: null,
    agent: null,
    card_number: null,
    customer_number: null,
    lop1_segmenttype: null,
    lop2_segmenttype: null,
  };

  const [applicationModel, setApplicationModel] = useState(
    initialApplicationModel
  );

  const [isNewChatOpen, setIsNewChatOpen] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState("");
  const [selectedPhoneTypeID, setSelectedPhoneTypeID] = useState(null);
  const [isSavingForm, setIsSavingForm] = useState(false);
  const [form, setForm] = useState(null);
  const [isEditingApplication, setIsEditingApplication] = useState(false);
  const [isApplicationSubmitting, setIsApplicationSubmitting] = useState(false);

  // Used on WABA chat when sending a call permission request
    const [isSendingCallPermissionRequest, setIsSendingCallPermissionRequest] =
      useState(false);

  const dispatch = useDispatch();

  const { dialMode, isInAutoDial, pendingStatusReason } = useSelector(
    (state) => state.agent
  );

  const { CurrentState, myInfo } = useSelector((state) => state.auth);
  const { stateCall } = useSelector((state) => state.call);
  const { getAssignmentDetails } = useSelector((state) => state.outbound);
  const { width } = useWindowDimensions();

  useEffect(() => {
    setIsLoading(true);

    fetchDetailAssignment(
      isTelemarketing && dialMode === "predictive"
        ? stateCall.AssignmentID
        : null
    );
  }, [getAssignmentDetails, assignmentID]);

  // Refetch data when stateCall is detected empty (when call is over) to update action log table
  useEffect(() => {
    if (Object.keys(stateCall).length === 0 && !isLoading) {
      fetchDetailAssignment();
    }
  }, [stateCall]);

  const columns = [
    {
      field: "InteractionTime",
      flex: 1.25,
      headerName: "Time",

      renderCell: (params) =>
        moment.utc(params.row.InteractionTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      align: "center",
      field: "PhoneTypeID",
      flex: 0.8,
      headerName: "Action Type",
      minWidth: 85,

      renderCell: (params) => {
        let icon;

        switch (params.row.InteractionType) {
          case "MANUALCALL":
          case "AUTOMATICCALL":
            params.row.IsWABACall
              ? (icon = "ic:baseline-whatsapp")
              : (icon = "ic:baseline-local-phone");

            break;

          // case 2:
          //   icon = "material-symbols:mail-outline";
          //   break;

          // case 5:
          //   break; // Special case, uses custom icon

          case "WHATSAPP":
            icon = "ic:baseline-whatsapp";
            break;

          case "WABA":
            icon = "hugeicons:whatsapp-business";
            break;

          default:
            break;
        }

        return params.row.ContactID === 5 ? (
          <LiveChatOngoingIcon fill="#7e7e7e" height="32" width="32" />
        ) : (
          <Icon color="#7e7e7e" height="26" icon={icon} width="26" />
        );
      },
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "By Agent",
    },

    {
      field: "Duration",
      flex: 0.6,
      headerName: "Duration",
      renderCell: (params) => formatSecondsToDuration(params.row.Duration),
    },

    {
      field: "Address",
      flex: 1,
      headerName: "Phone No",
    },

    {
      field: "InteractionStatus",
      flex: 1.4,
      headerName: "Action Code",
    },

    {
      field: "InteractionType",
      flex: 1,
      headerName: "State",
    },

    {
      field: "Comments",
      flex: 1,
      headerName: "Comments",
    },

    {
      field: "action",
      flex: 0.75,
      headerName: "Action",

      renderCell: (params) => (
        <ActionColumn
          params={params}
          setSelectedChatListID={setSelectedChatListID}
          setSelectedTranscription={setSelectedTranscription}
          setSelectedWAID={setSelectedWAID}
          setIsModalHistoryShown={setIsModalHistoryShown}
          setisModalTranscriptionShown={setIsModalTranscriptionShown}
        />
      ),
    },
  ];

  /* const columnsStatusLog = [
    {
      field: "submitTime",
      flex: 1,
      headerName: "Submit Time",

      renderCell: (params) =>
        moment(params.row.submitTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "byAgents",
      flex: 1,
      headerName: "By Agents",
    },

    {
      field: "comments",
      flex: 1,
      headerName: "Comments",
    },
  ]; */

  const columnsApplication = [
    {
      field: "SubmitTime",
      flex: 1,
      headerName: "Submit Time",
      renderCell: (params) => params.row.SubmitTime ?? "Not submitted",
    },

    {
      field: "ApplicationType",
      flex: 1,
      headerName: "Application Type",
    },

    {
      field: "status",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "CreatedOn",
      flex: 1,
      headerName: "Created On",

      /* renderCell: (params) =>
        moment(params.row.CreatedOn).format("DD-MMM-yyyy"), */
    },

    {
      field: "action",
      flex: 0.5,
      headerName: "Action",

      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setIsApplicationLoading(true);
              setSelectedApplication(params.row);

              getApplicationDetail({ applicationid: params.row.applicationid })
                .then((response) => {
                  if (response.status) {
                    setApplicationDetails(response.data);
                    setIsApplicationLoading(false);
                  } else {
                    console.log("error", response.error);
                    setIsApplicationLoading(false);
                  }
                })
                .catch((err) => {
                  setIsApplicationLoading(false);
                  console.log("err", err);
                });
            }}
          >
            <Icon
              color="#7e7e7e"
              height="26"
              icon="ic:baseline-remove-red-eye"
            />
          </IconButton>
        );
      },
    },
  ];

  const columnsVisitHistory = [
    {
      field: "InteractionTime",
      flex: 1.25,
      headerName: "Time",

      renderCell: (params) =>
        moment(params.row.InteractionTime).format("dddd, DD MMMM HH:mm"),
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent name",
    },

    {
      field: "ISGroupName",
      flex: 1,
      headerName: "Status group",
    },

    {
      field: "ISCodeName",
      flex: 1,
      headerName: "Status name",
    },

    {
      field: "Comments",
      flex: 1,
      headerName: "Notes",
    },

    {
      field: "action",
      flex: 0.5,
      headerName: "Action",

      renderCell: (params) => (
        <Tooltip arrow placement="top" title="View picture">
          <IconButton
            onClick={() => {
              setSelectedImage(params.row.ImagePath);
              setIsImageOpen(true);
            }}
          >
            <Icon height="26" icon="bxs:image" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const renderContactDetailsFields = () => {
    const fields = [];

    const entries = Object.entries(
      isTelemarketing ? detailTSS.contactDetails : contactDetails
    );

    entries.forEach((element, index) => {
      fields.push(
        <TextField
          InputProps={{
            readOnly: true,
          }}
          key={index}
          label={entries[index][0]}
          value={entries[index][1] ? entries[index][1] : ""}
        />
      );
    });

    return fields;
  };

  const renderApplicationDetailsFields = () => {
    const fields = [];
    const entries = Object.entries(applicationDetails.appdetail[0]);

    entries.forEach((element, index) => {
      fields.push(
        <TextField
          InputProps={{
            readOnly: true,
          }}
          key={index}
          label={entries[index][0]}
          value={entries[index][1] ? entries[index][1] : ""}
        />
      );
    });

    return fields;
  };

  const renderApplicationVerificationFields = () => {
    const fields = [];

    applicationVerificationFields.forEach((field, index) => {
      fields.push(
        <VerificationField
          detailTSS={detailTSS}
          index={index}
          inputParam={field.inputParam}
          isVerificationFieldsLocked={isVerificationFieldsLocked}
          key={index}
          label={field.label}
          setIsVerificationFieldsLocked={setIsVerificationFieldsLocked}
          setVerifiedFields={setVerifiedFields}
          submittedValues={filterSubmittedValues(field.inputParam)}
          verifiedFields={verifiedFields}
        />
      );
    });

    return fields;
  };

  const fetchDetailAssignment = (nextAssignmentID) => {
    setIsLoading(true);
    setIsNotFound(false);

    if (isTelemarketing) {
      getDetailAssignmentTSS({ assignmentid: nextAssignmentID ?? assignmentID })
        .then((response) => {
          if (response.status) {
            console.log("Detail assignment TSS: ", response.data);
            setDetailTSS(response.data);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
            setIsNotFound(true);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setIsNotFound(true);
          console.log("err", err);
        });
    } else {
      getDetailAssignment({
        assignmentid: assignmentID,
        contactid: stateCall.ContactID ? stateCall.ContactID : null,
        campaignid: stateCall.CampaignID ? stateCall.CampaignID : null,
      })
        .then((response) => {
          if (response.status) {
            console.log("Detail assignment: ", response.data);
            setContactInfo(response.data.data1);
            setContactDetails(response.data.data[0][0]);
            setPrefix(response.data.data[0][0].DialPrefix);
            setVisitHistory(response.data.data2);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
            setIsNotFound(true);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setIsNotFound(true);
          console.log("err", err);
        });
    }
  };

  function calculateCicilan(pinjaman, tenor, bunga) {
    let pinjamanNumber = Number(pinjaman),
      tenorNumber = Number(tenor),
      bungaNumber = Number(bunga);

    return Math.floor(
      pinjamanNumber / tenorNumber + (bungaNumber * pinjamanNumber) / 100
    ).toString();
  }

  function filterSubmittedValues(inputParam) {
    let filteredEntries;

    if(submittedValues) {
      filteredEntries = Object.entries(submittedValues).filter(([key]) =>
        key.includes(inputParam.toLowerCase())
      );
    } else {
      filteredEntries = [];
    }

    return Object.fromEntries(filteredEntries);
  }

  function handleMapClose() {
    setSelectedImage("");
    setIsImageOpen(false);
  }

  const sendMessage = (childMsgParam) => {
    dispatch(
      sendChat(
        childMsgParam.contactname,
        childMsgParam.newchat,
        childMsgParam.number,
        childMsgParam.session,
        childMsgParam.type,
        childMsgParam.message,
        childMsgParam.caption,
        childMsgParam.filename,
        childMsgParam.curChatID, // curChatID if newchat always 0
        contactDetails.RecordID,
        contactInfo[0][0].ContactID,
        contactInfo[0][0].CampaignID,
        selectedPhoneTypeID,
      )
    );

    // setFile64({ name: null, base64: null, type: null });
  };

  return (
    <div className="assignment-details">
      <header className="assignment-details-header">
        <p>Assignment Info</p>

        <IconButton
          disabled={isInAutoDial}
          onClick={() => {
            dispatch({
              type: SET_CALL_SCHEDULE_ASSIGNMENT_ID,
              payload: null,
            });

            setSelectedAssignment(null);

            // Reset agent selected assignment
            dispatch({
              type: SET_AGENT_SELECTED_ASSIGNMENT,
              payload: null,
            });
          }}
        >
          <Icon color="#fff" icon="ph:x-bold" width="20" height="20" />
        </IconButton>
      </header>

      <div className="assignment-details-content">
        {isLoading ? (
          <Loader />
        ) : isNotFound ? (
          <p className="not-found">Assignment not found</p>
        ) : (
          <>
            <section className="item contact-info">
              <div className="item-inner info-name">
                <div className="data">
                  <Icon
                    icon="mdi:account-circle"
                    color="#e7e8ec"
                    width="60"
                    height="60"
                  />

                  <div className="name-ref">
                    <p className="name">
                      {isTelemarketing
                        ? detailTSS.customerName
                        : contactInfo[0][0].ContactName}
                    </p>

                    <p className="ref">
                      Ref.{" "}
                      {isTelemarketing
                        ? detailTSS.contact.contactref
                        : contactInfo[0][0].ContactRef}
                    </p>
                  </div>

                  {isTelemarketing ? (
                    <div className="campaign-name">
                      <Icon height="20" icon="material-symbols:flag" />
                      <p>{detailTSS.campaignDetails.campaignname}</p>
                    </div>
                  ) : (
                    /* <div className="tags">
                      <Icon height="16" icon="mdi:tag" width="16" />
                      <p>Urgent, Janji Bayar</p>
                    </div> */

                    contactDetails?.ChatListID && (
                      <div className="buttons">
                        <Button
                          variant="contained"
                          onClick={() => {
                            dispatch({
                              type: SET_ASSIGNMENT_CHAT_LIST_ID,
                              payload: contactDetails?.ChatListID,
                            });

                            changePage("chat");
                          }}
                        >
                          View Chat
                        </Button>
                      </div>
                    )
                  )}
                </div>

                {isTelemarketing && (
                  <>
                    {/* Hide if there is no active policy */}
                    <div className="active-policies">
                      <p>Paket Alpha</p>
                      <p>Paket Bravo</p>
                      <p>Paket Charlie</p>
                    </div>

                    <div className="buttons">
                      <Button
                        startIcon={
                          <Icon height="20" icon="fluent:script-20-filled" />
                        }
                        variant="contained"
                      >
                        View Script
                      </Button>

                      <Button
                        startIcon={
                          <Icon
                            height="20"
                            icon="material-symbols:calculate-rounded"
                          />
                        }
                        variant="contained"
                      >
                        Calculate Premi
                      </Button>
                    </div>
                  </>
                )}
              </div>

              <div className="item-inner info-numbers">
                <header className={isContactInfoCollapsed ? "collapsed" : ""}>
                  <p>Contact Information</p>

                  <IconButton
                    onClick={() =>
                      setIsContactInfoCollapsed((prevState) => !prevState)
                    }
                  >
                    <Icon
                      icon={`icon-park:${
                        isContactInfoCollapsed ? "up" : "down"
                      }`}
                      width="20"
                      height="20"
                    />
                  </IconButton>
                </header>

                <Collapse in={isContactInfoCollapsed} unmountOnExit>
                  <ContactInformation
                    data={
                      isTelemarketing ? detailTSS.contactPhone : contactInfo[1]
                    }
                    contactID={
                      isTelemarketing
                        ? detailTSS.assignment.contactid
                        : contactInfo[0][0].ContactID
                    }
                    campaignID={
                      isTelemarketing
                        ? detailTSS.assignment.campaignid
                        : contactInfo[0][0].CampaignID
                    }
                    name={
                      isTelemarketing
                        ? detailTSS.customerName
                        : contactInfo[0][0].ContactName
                    }
                    setIsAddEditContactDialogShown={
                      setIsAddEditContactDialogShown
                    }
                    isAddEditButtonShown
                    prefix={prefix}
                    acwMode={acwMode}
                    acwDuration={acwDuration}
                    isTelemarketing={isTelemarketing}
                    setIsNewChatOpen={setIsNewChatOpen}
                    setSelectedNumber={setSelectedNumber}
                    setSelectedPhoneTypeID={setSelectedPhoneTypeID}
                  />
                </Collapse>
              </div>
            </section>

            <section className="item contact-details">
              <header className={isContactDetailsCollapsed ? "collapsed" : ""}>
                <p>Contact Details</p>

                <IconButton
                  onClick={() =>
                    setIsContactDetailsCollapsed((prevState) => !prevState)
                  }
                >
                  <Icon
                    icon={`icon-park:${
                      isContactDetailsCollapsed ? "up" : "down"
                    }`}
                    width="20"
                    height="20"
                  />
                </IconButton>
              </header>

              <Collapse in={isContactDetailsCollapsed} unmountOnExit>
                <div className="item-inner">{renderContactDetailsFields()}</div>
              </Collapse>
            </section>

            {isTelemarketing && (
              <section className="item application">
                <header className={isApplicationCollapsed ? "collapsed" : ""}>
                  <div className="title">
                    {(isApplicationFormDetailShown ||
                      isApplicationVerificationShown ||
                      selectedApplication) && (
                      <IconButton
                        onClick={() => {
                          setIsEditingApplication(false);

                          selectedApplication
                            ? setSelectedApplication(null)
                            : isApplicationFormDetailShown
                            ? setIsApplicationFormDetailShown(false)
                            : setIsApplicationVerificationShown(false);
                        }}
                      >
                        <Icon
                          height="20"
                          icon="material-symbols:arrow-back-ios-new-rounded"
                        />
                      </IconButton>
                    )}
                    <p>
                      {isApplicationFormDetailShown || selectedApplication
                        ? "Application"
                        : "Verification"}
                    </p>
                  </div>

                  <IconButton
                    onClick={() =>
                      setIsApplicationCollapsed((prevState) => !prevState)
                    }
                  >
                    <Icon
                      height="20"
                      icon={`icon-park:${
                        isApplicationCollapsed ? "up" : "down"
                      }`}
                    />
                  </IconButton>
                </header>

                <Collapse in={isApplicationCollapsed} unmountOnExit>
                  {isApplicationFormDetailShown ? (
                    <>
                      <div className="item-inner application-form-detail">
                        <section>
                          <p>Info Customer</p>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Nomor rekening"
                            value={applicationModel.norekening}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                norekening: event.target.value,
                              })
                            }
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Nama penerima dana"
                            value={applicationModel.namapenerimadana}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                namapenerimadana: event.target.value,
                              })
                            }
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Kota cabang buka rekening OCBC"
                            value={applicationModel.kotacabang}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                kotacabang: event.target.value,
                              })
                            }
                          />
                        </section>

                        <section>
                          <p>LOP</p>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Tipe"
                            select
                            value={applicationModel.lop1_segmenttype ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop1_segmenttype: event.target.value,
                              })
                            }
                          >
                            {form.segment.map((segment) => (
                              <MenuItem key={segment.id} value={segment.id}>
                                {segment.name}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Bunga"
                            select
                            value={applicationModel.lop1_bunga ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop1_bunga: event.target.value,

                                lop1_cicilan: calculateCicilan(
                                  applicationModel.lop1_pinjaman ?? 0,
                                  applicationModel.lop1_tenor ?? 0,
                                  event.target.value
                                ),
                              })
                            }
                          >
                            {applicationModel.lop1_segmenttype ? (
                              form.interest
                                .filter(
                                  (interest) =>
                                    interest.segment ===
                                    applicationModel.lop1_segmenttype
                                )
                                .map((interest) => (
                                  <MenuItem
                                    key={interest.id}
                                    value={interest.id}
                                  >
                                    {interest.name}
                                  </MenuItem>
                                ))
                            ) : (
                              <MenuItem disabled>Select type</MenuItem>
                            )}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Tenor"
                            select
                            value={applicationModel.lop1_tenor ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,

                                lop1_cicilan: calculateCicilan(
                                  applicationModel.lop1_pinjaman ?? 0,
                                  event.target.value,
                                  applicationModel.bunga1 ?? 0
                                ),

                                lop1_tenor: event.target.value,
                              })
                            }
                          >
                            {form.tenor.map((tenor) => (
                              <MenuItem key={tenor.id} value={tenor.id}>
                                {tenor.name} bulan
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Pinjaman"
                            value={applicationModel.lop1_pinjaman ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,

                                lop1_cicilan: calculateCicilan(
                                  event.target.value,
                                  applicationModel.lop1_tenor ?? 0,
                                  applicationModel.lop1_bunga ?? 0
                                ),

                                lop1_pinjaman: event.target.value,
                              })
                            }
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            label="Cicilan"
                            value={applicationModel.lop1_cicilan ?? ""}
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Admin"
                            select
                            value={applicationModel.lop1_admin ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop1_admin: event.target.value,
                              })
                            }
                          >
                            {applicationModel.lop1_segmenttype ? (
                              form.admin
                                .filter(
                                  (admin) =>
                                    admin.segment ===
                                    applicationModel.lop1_segmenttype
                                )
                                .map((admin) => (
                                  <MenuItem key={admin.id} value={admin.id}>
                                    {admin.name}
                                  </MenuItem>
                                ))
                            ) : (
                              <MenuItem disabled>Select type</MenuItem>
                            )}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Tipe"
                            select
                            value={applicationModel.lop2_segmenttype ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop2_segmenttype: event.target.value,
                              })
                            }
                          >
                            {form.segment.map((segment) => (
                              <MenuItem key={segment.id} value={segment.id}>
                                {segment.name}
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Bunga"
                            select
                            value={applicationModel.lop2_bunga ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop2_bunga: event.target.value,

                                lop2_cicilan: calculateCicilan(
                                  applicationModel.lop2_pinjaman ?? 0,
                                  applicationModel.lop2_tenor ?? 0,
                                  event.target.value
                                ),
                              })
                            }
                          >
                            {applicationModel.lop2_segmenttype ? (
                              form.interest
                                .filter(
                                  (interest) =>
                                    interest.segment ===
                                    applicationModel.lop2_segmenttype
                                )
                                .map((interest) => (
                                  <MenuItem
                                    key={interest.id}
                                    value={interest.id}
                                  >
                                    {interest.name}
                                  </MenuItem>
                                ))
                            ) : (
                              <MenuItem disabled>Select type</MenuItem>
                            )}
                          </TextField>

                          <TextField
                            fullWidth
                            label="Tenor"
                            select
                            value={applicationModel.lop2_tenor ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,

                                lop2_cicilan: calculateCicilan(
                                  applicationModel.lop2_pinjaman ?? 0,
                                  event.target.value,
                                  applicationModel.bunga1 ?? 0
                                ),

                                lop2_tenor: event.target.value,
                              })
                            }
                          >
                            {form.tenor.map((tenor) => (
                              <MenuItem key={tenor.id} value={tenor.id}>
                                {tenor.name} bulan
                              </MenuItem>
                            ))}
                          </TextField>

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Pinjaman"
                            value={applicationModel.lop2_pinjaman ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,

                                lop2_cicilan: calculateCicilan(
                                  event.target.value,
                                  applicationModel.lop2_tenor ?? 0,
                                  applicationModel.lop2_bunga ?? 0
                                ),

                                lop2_pinjaman: event.target.value,
                              })
                            }
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly: true,
                            }}
                            label="Cicilan"
                            value={applicationModel.lop2_cicilan ?? ""}
                          />

                          <TextField
                            fullWidth
                            InputProps={{
                              readOnly:
                                applicationDetails?.appdetail[0].issubmitted,
                            }}
                            label="Admin"
                            select
                            value={applicationModel.lop2_admin ?? ""}
                            onChange={(event) =>
                              setApplicationModel({
                                ...applicationModel,
                                lop2_admin: event.target.value,
                              })
                            }
                          >
                            {applicationModel.lop2_segmenttype ? (
                              form.admin
                                .filter(
                                  (admin) =>
                                    admin.segment ===
                                    applicationModel.lop2_segmenttype
                                )
                                .map((admin) => (
                                  <MenuItem key={admin.id} value={admin.id}>
                                    {admin.name}
                                  </MenuItem>
                                ))
                            ) : (
                              <MenuItem disabled>Select type</MenuItem>
                            )}
                          </TextField>
                        </section>

                        <section className="clausa">
                          <p>Clausa LOP</p>

                          <div>
                            <p>
                              TERIMA KASIH ATAS VERIFIKASI DATA YANG DIBERIKAN
                              DAN PERCAKAPAN INI DIREKAM DARI AWAL HINGGA AKHIR
                              MOHON DISIMAK TERLEBIHI DAHULU JIKA ADA PERTANYAAN
                              SILAHKAN DITANYAKAN SETELAH PEMBACAAN CLAUSA
                            </p>

                            <p>
                              BERIKUT KONFIRMASINYA
                              <br />
                              PADA HARI INI HARI..TGL..BULAN..TAHUN… SAYA
                              …MENGINFORMASIKAN BAHWA ATAS NAMA BAPAK/IBU…TELAH
                              SETUJU MENGIKUTI PROGRAM LOP ATAU PENCAIRAN DANA
                              TUNAI YANG DIAMBIL DARI SEBAGIAN LIMIT KARTU
                              KREDIT ….DENGAN NOMINAL DANA ….TENOR…BUNGA…ADMIN
                              FEE..DAN CICILAN PERBULANNYA….RUPIAH
                              <br />
                              (RINCIIN JIKA NASABAH MENGAMBIL 2 LOP)
                              <br />
                              NANTI DIBILLING TAGIHAN BAPAK/IBU AKAN ADA 2 LOP
                              <br />
                              LOPPERTAMA…RUPIAH, TENOR..ADMIN FEE…CICILAN PER
                              BULAN…RUPIAH
                            </p>

                            <p>
                              LOP KEDUA …RUPIAH, TENOR…ADMIN FEE…CICILAN
                              PERBULAN…RUPIAH
                              <br />
                              SEHINGGA DANA YANG BAPAK TERIMA MENJADI …RUPIAH,
                              TENOR..ADMIN FEE..CICILAN PER BULAN..RUPIAH
                              <br />
                              DANA AKAN DITRANSFER KE REKENING OCBC NISP A,N
                              BAPAK/IBU, NO REKENING…CABANG KOTA…
                              <br />
                              PROGRAM LOP AKAN DICETAK SESUAI DENGAN TANGGAL
                              CETAK BILLING KARTU BAPAK YAITU TGL …BULAN…SEHIGGA
                              JATUH TEMPO NYA ….
                            </p>

                            <p>
                              JIKA BAPAK INGIN MELAKUKAN PELUNASAN DIPERCEPAT
                              AKAN DIKENAKAN BIAYA PINALTI 200.000 PER LOP,
                              PROSES LOP INI MASIH MERUPAKAN INDIKASI PENGAJUAN
                              DAN BANK BERHAK MELAKUKAN PEMBATALAN APABILA SISA
                              LIMIT KARTU KREDIT BAPAK TIDAK MENCUKUPI ATAU
                              BERUBAH KETIKA LOP DIPROSES OLEH KARENA ITU MOHON
                              UNTUK MENJAGA PEMAKAIAN KARTU KREDIT NYA AGAR
                              TIDAK OVER LIMIT/MENGALAMI PERGESERAN LIMIT KARTU
                            </p>

                            <p>
                              JIKA LOP TIDAK BERHASIL DI PROSES MAKA KAMI AKAN
                              MENGIRIMKAN INFORMASI BERUPA SMS KE NO HANDPHONE
                              YANG TERDAFTAR DI OCBC
                            </p>

                            <p>
                              APAKAH BAPAK/IBU SUDAH MENGERTI DAN SETUJU UNTUK
                              KAMI LANJUTKAN PROSES LOP NYA ?<br />
                              ( TUNGGU SAMPAI DIRESPON SETUJU OLEH NASABAH )
                              <br />
                              TERIMA KASIH ATAS KESEDIAAN WAKTUNYA, SEHAT DAN
                              SUKSES SELALU UNTUK BAPAK/IBU…
                            </p>
                          </div>
                        </section>

                        {!applicationDetails?.appdetail[0].issubmitted && (
                          <Button
                            className="save-form-button"
                            disabled={isSavingForm}
                            variant="contained"
                            onClick={() => {
                              setIsSavingForm(true);

                              saveForm({
                                model: applicationModel,

                                apptypeid: isEditingApplication
                                  ? applicationDetails.appdetail[0]
                                      .applicationtypeid
                                  : selectedApplicationForm,

                                applicationid: isEditingApplication
                                  ? form.appid
                                  : 0,

                                assignment: detailTSS.assignment,
                                leaddetail: detailTSS.contactDetails,
                              })
                                .then((response) => {
                                  if (response.status) {
                                    setIsSavingForm(false);
                                    setIsApplicationFormDetailShown(false);
                                    setIsEditingApplication(false);

                                    toast.success(
                                      "Form saved successfully.",

                                      {
                                        autoClose: 3000,
                                      }
                                    );

                                    fetchDetailAssignment();
                                  } else {
                                    console.log("error", response.error);
                                    setIsSavingForm(false);
                                    setIsEditingApplication(false);

                                    toast.error(
                                      "Error saving form.",

                                      {
                                        autoClose: 3000,
                                      }
                                    );
                                  }
                                })
                                .catch((err) => {
                                  setIsSavingForm(false);
                                  setIsEditingApplication(false);

                                  toast.error(
                                    "Error saving form.",

                                    {
                                      autoClose: 3000,
                                    }
                                  );

                                  console.log("err", err);
                                });
                            }}
                          >
                            {isEditingApplication ? "Update form" : "Save form"}
                          </Button>
                        )}
                      </div>

                      {/* <p className="status-log-title">Status Log</p>

                      <DataGrid
                        autoPageSize
                        className="item-inner status-log"
                        columns={columnsStatusLog}
                        disableColumnFilter
                        disableColumnMenu
                        disableSelectionOnClick
                        headerHeight={75}
                        hideFooter
                        rows={dummyStatusLog}
                      /> */}
                    </>
                  ) : isApplicationVerificationShown ? (
                    <div className="item-inner application-verification">
                      {renderApplicationVerificationFields()}

                      <div className="submit-verification">
                        {verifiedFields < 5 ? (
                          <p>Verification passed: {verifiedFields} / 5</p>
                        ) : (
                          <Button
                            startIcon={
                              <Icon
                                height="20"
                                icon="ic:baseline-remove-red-eye"
                              />
                            }
                            variant="contained"
                            onClick={() => {
                              setIsApplicationVerificationShown(false);
                              setIsApplicationLoading(true);

                              getForm({
                                leaddetail: detailTSS.contactDetails,
                                assignmentid: detailTSS.assignment.assignmentid,
                                campaignid: detailTSS.assignment.campaignid,
                                formtypeid: selectedApplicationForm,
                                allowedit: 1,
                                tablerecid: 0,
                                applicationid: 0,
                              })
                                .then((response) => {
                                  if (response.status) {
                                    setIsLoadingVerificationValues(false);
                                    setForm(response.data);
                                    setIsApplicationFormDetailShown(true);
                                  } else {
                                    console.log("error", response.error);
                                    setIsLoadingVerificationValues(false);
                                  }
                                })
                                .catch((err) => {
                                  setIsLoadingVerificationValues(false);
                                  console.log("err", err);
                                });
                            }}
                          >
                            Show application
                          </Button>
                        )}
                      </div>
                    </div>
                  ) : selectedApplication ? (
                    <>
                      <div className="item-inner application-detail">
                        {isApplicationLoading ? (
                          <Loader />
                        ) : (
                          <>
                            <div className="application-detail-fields">
                              {renderApplicationDetailsFields()}
                            </div>

                            <div className="application-detail-buttons">
                              {myInfo.user.AgentTSS.AgentTypeID === 12 &&
                              selectedApplication.issubmitted ? (
                                <Button
                                  className="view-qa-button"
                                  variant="contained"
                                  onClick={() => setIsQAFormDialogShown(true)}
                                >
                                  View QA
                                </Button>
                              ) : (
                                <>
                                  <Button
                                    className="cancel-application-button"
                                    disabled={isApplicationSubmitting}
                                    variant="contained"
                                    onClick={() => {
                                      setIsApplicationSubmitting(true);

                                      cancelApplication({
                                        appdetail: applicationDetails.appdetail,
                                      })
                                        .then((response) => {
                                          if (
                                            response.status &&
                                            response.data.issuccess
                                          ) {
                                            setIsApplicationSubmitting(false);
                                            setSelectedApplication(null);

                                            toast.success(
                                              "Application cancelled!",

                                              {
                                                autoClose: 3000,
                                              }
                                            );

                                            fetchDetailAssignment();
                                          } else {
                                            console.log(
                                              "error",
                                              response.error
                                            );
                                            setIsApplicationSubmitting(false);

                                            toast.error(
                                              "Error cancelling application.",

                                              {
                                                autoClose: 3000,
                                              }
                                            );
                                          }
                                        })
                                        .catch((err) => {
                                          setIsApplicationSubmitting(false);

                                          toast.error(
                                            "Error cancelling application.",

                                            {
                                              autoClose: 3000,
                                            }
                                          );

                                          console.log("err", err);
                                        });
                                    }}
                                  >
                                    Cancel application
                                  </Button>

                                  <Button
                                    className={
                                      selectedApplication.issubmitted
                                        ? "submitted"
                                        : ""
                                    }
                                    disabled={isApplicationSubmitting}
                                    variant="contained"
                                    onClick={() => {
                                      setIsApplicationLoading(true);
                                      setSelectedApplication(null);

                                      getForm({
                                        leaddetail: detailTSS.contactDetails,
                                        assignmentid:
                                          detailTSS.assignment.assignmentid,
                                        campaignid:
                                          detailTSS.assignment.campaignid,
                                        formtypeid:
                                          applicationDetails.appdetail[0]
                                            .applicationtypeid,
                                        allowedit: applicationDetails.allowedit,
                                        tablerecid:
                                          applicationDetails.appdetail[0]
                                            .sourcetablerecid,
                                        applicationid:
                                          applicationDetails.appdetail[0]
                                            .applicationid,
                                      })
                                        .then((response) => {
                                          if (response.status) {
                                            setIsApplicationLoading(false);
                                            setForm(response.data);
                                            setApplicationModel(
                                              response.data.model
                                            );
                                            setIsEditingApplication(true);
                                            setIsApplicationFormDetailShown(
                                              true
                                            );
                                          } else {
                                            console.log(
                                              "error",
                                              response.error
                                            );
                                            setIsApplicationLoading(false);

                                            toast.error(
                                              "Error loading form.",

                                              {
                                                autoClose: 3000,
                                              }
                                            );
                                          }
                                        })
                                        .catch((err) => {
                                          setIsApplicationLoading(false);

                                          toast.error(
                                            "Error loading form.",

                                            {
                                              autoClose: 3000,
                                            }
                                          );

                                          console.log("err", err);
                                        });
                                    }}
                                  >
                                    {selectedApplication.issubmitted
                                      ? "View application"
                                      : "Edit application"}
                                  </Button>

                                  {!selectedApplication.issubmitted && (
                                    <Button
                                      disabled={isApplicationSubmitting}
                                      variant="contained"
                                      onClick={() => {
                                        setIsApplicationSubmitting(true);

                                        submitApplication({
                                          appdetail:
                                            applicationDetails.appdetail,
                                        })
                                          .then((response) => {
                                            if (
                                              response.status &&
                                              response.data.issuccess
                                            ) {
                                              setIsApplicationSubmitting(false);
                                              setSelectedApplication(null);

                                              toast.success(
                                                "Application submitted!",

                                                {
                                                  autoClose: 3000,

                                                  onClose: () => {
                                                    if (
                                                      dialMode ===
                                                        "progressive" &&
                                                      pendingStatusReason === ""
                                                    ) {
                                                      dispatch({
                                                        type: GET_NEXT_ASSIGNMENT,
                                                      });
                                                    } else if (
                                                      dialMode ===
                                                        "predictive" &&
                                                      pendingStatusReason === ""
                                                    ) {
                                                      dispatch({
                                                        type: SET_AUTO_DIAL,
                                                        payload: false,
                                                      });

                                                      dispatch({
                                                        type: SET_DIAL_MODE,
                                                        payload: "",
                                                      });
                                                    }
                                                  },
                                                }
                                              );

                                              dispatch({
                                                type: SET_GO_TO_ACW,
                                                payload: false,
                                              });

                                              if (pendingStatusReason !== "") {
                                                // If there is a pending status change, set status to the pending status
                                                dispatch(
                                                  stateAction(
                                                    "AUX",
                                                    pendingStatusReason,
                                                    "ACW",
                                                    "Orange"
                                                  )
                                                );

                                                dispatch({
                                                  type: SET_PENDING_STATUS_REASON,
                                                  payload: "",
                                                });

                                                dispatch({
                                                  type: SET_AUTO_DIAL,
                                                  payload: false,
                                                });
                                              } else {
                                                // Else, change status to READY if in ACW
                                                if (CurrentState === "ACW") {
                                                  dispatch(
                                                    stateAction(
                                                      "READY",
                                                      undefined,
                                                      "ACW",
                                                      "Green"
                                                    )
                                                  );
                                                }
                                              }

                                              fetchDetailAssignment();
                                            } else {
                                              console.log(
                                                "error",
                                                response.error
                                              );
                                              setIsApplicationSubmitting(false);

                                              toast.error(
                                                "Error submitting application.",

                                                {
                                                  autoClose: 3000,
                                                }
                                              );
                                            }
                                          })
                                          .catch((err) => {
                                            setIsApplicationSubmitting(false);

                                            toast.error(
                                              "Error submitting application.",

                                              {
                                                autoClose: 3000,
                                              }
                                            );

                                            console.log("err", err);
                                          });
                                      }}
                                    >
                                      Submit application
                                    </Button>
                                  )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="item-inner select-application">
                        <TextField
                          fullWidth
                          label="Select application"
                          select
                          value={selectedApplicationForm}
                          onChange={(e) =>
                            setSelectedApplicationForm(e.target.value)
                          }
                        >
                          {detailTSS.applicationForm.map((form) => (
                            <MenuItem key={form.id} value={form.id}>
                              {form.name}
                            </MenuItem>
                          ))}
                        </TextField>

                        <Button
                          disabled={
                            isLoadingVerificationValues ||
                            !selectedApplicationForm
                              ? true
                              : false
                          }
                          startIcon={
                            <Icon height="20" icon="fluent:script-20-filled" />
                          }
                          variant="contained"
                          onClick={() => {
                            setIsLoadingVerificationValues(true);

                            getContactVerification({
                              contactid: detailTSS.assignment.contactid,
                              campaignid: detailTSS.assignment.campaignid,
                            })
                              .then((response) => {
                                if (response.status) {
                                  setVerifiedFields(
                                    response.data?.passedcount
                                      ? response.data.passedcount
                                      : 0
                                  );

                                  setSubmittedValues(response.data?.avm);

                                  if (response.data?.passedcount >= 5) {
                                    getForm({
                                      leaddetail: detailTSS.contactDetails,
                                      assignmentid:
                                        detailTSS.assignment.assignmentid,
                                      campaignid:
                                        detailTSS.assignment.campaignid,
                                      formtypeid: selectedApplicationForm,
                                      allowedit: 1,
                                      tablerecid: 0,
                                      applicationid: 0,
                                    })
                                      .then((response) => {
                                        if (response.status) {
                                          setIsLoadingVerificationValues(false);
                                          setForm(response.data);
                                          setIsApplicationFormDetailShown(true);
                                        } else {
                                          console.log("error", response.error);
                                          setIsLoadingVerificationValues(false);
                                        }
                                      })
                                      .catch((err) => {
                                        setIsLoadingVerificationValues(false);
                                        console.log("err", err);
                                      });
                                  } else {
                                    if (
                                      response.data?.avm.dobverifresult ===
                                      "PASSED"
                                    ) {
                                      setIsVerificationFieldsLocked(false);
                                    }

                                    setIsApplicationVerificationShown(true);
                                  }
                                } else {
                                  console.log("error", response.error);

                                  toast.error(
                                    "Error getting verification values.",

                                    {
                                      autoClose: 3000,
                                    }
                                  );

                                  setIsLoadingVerificationValues(false);
                                }
                              })
                              .catch((err) => {
                                toast.error(
                                  "Error getting verification values.",

                                  {
                                    autoClose: 3000,
                                  }
                                );

                                console.log("err", err);
                                setIsLoadingVerificationValues(false);
                              });
                          }}
                        >
                          {isLoadingVerificationValues
                            ? "Loading..."
                            : "Fill Form"}
                        </Button>
                      </div>

                      {/* Show when there is more than 1 application running */}
                      <DataGrid
                        autoPageSize
                        className="item-inner application-table"
                        columns={columnsApplication}
                        disableColumnFilter
                        disableColumnMenu
                        disableSelectionOnClick
                        headerHeight={75}
                        rows={detailTSS.applicationList}
                        getRowId={(row) => row.applicationid}
                      />
                    </>
                  )}
                </Collapse>
              </section>
            )}

            {/* <section className="item custom-table">
              <header className={isCustomTableCollapsed ? "collapsed" : ""}>
                <p>Custom Table</p>

                <IconButton
                  onClick={() =>
                    setIsCustomTableCollapsed((prevState) => !prevState)
                  }
                >
                  <Icon
                    icon={`icon-park:${isCustomTableCollapsed ? "up" : "down"}`}
                    width="20"
                    height="20"
                  />
                </IconButton>
              </header>

              <Collapse in={isCustomTableCollapsed} unmountOnExit>
                <DataGrid
                  autoPageSize
                  className="item-inner"
                  columns={columns}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  headerHeight={75}
                  rows={contactInfo[2]}
                  getRowId={(row) => row.InteractionID}
                />
              </Collapse>
            </section> */}

            <section className="item action-log">
              <header className={isActionLogCollapsed ? "collapsed" : ""}>
                <p>Action Log</p>

                <IconButton
                  onClick={() =>
                    setIsActionLogCollapsed((prevState) => !prevState)
                  }
                >
                  <Icon
                    icon={`icon-park:${isActionLogCollapsed ? "up" : "down"}`}
                    width="20"
                    height="20"
                  />
                </IconButton>
              </header>

              <Collapse in={isActionLogCollapsed} unmountOnExit>
                <DataGrid
                  autoPageSize
                  className="item-inner"
                  columns={columns}
                  disableColumnFilter
                  disableColumnMenu
                  disableSelectionOnClick
                  headerHeight={75}
                  rows={isTelemarketing ? detailTSS.actionlog : contactInfo[2]}
                  getRowId={(row) => row.InteractionID}
                />
              </Collapse>
            </section>

            {!isTelemarketing && (
              <section className="item visit-history">
                <header className={isVisitHistoryCollapsed ? "collapsed" : ""}>
                  <p>Visit History</p>

                  <IconButton
                    onClick={() =>
                      setIsVisitHistoryCollapsed((prevState) => !prevState)
                    }
                  >
                    <Icon
                      icon={`icon-park:${
                        isVisitHistoryCollapsed ? "up" : "down"
                      }`}
                      width="20"
                      height="20"
                    />
                  </IconButton>
                </header>

                <Collapse in={isVisitHistoryCollapsed} unmountOnExit>
                  <DataGrid
                    autoPageSize
                    className="item-inner"
                    columns={columnsVisitHistory}
                    disableColumnFilter
                    disableColumnMenu
                    disableSelectionOnClick
                    headerHeight={75}
                    rows={visitHistory}
                    getRowHeight={() => "auto"}
                    getRowId={(row) => row.InteractionID}
                  />
                </Collapse>
              </section>
            )}
          </>
        )}
      </div>

      <AddEditContactDialog
        isOpen={isAddEditContactDialogShown}
        contactID={
          isTelemarketing
            ? detailTSS?.assignment.contactid
            : contactInfo.length
            ? contactInfo[0][0].ContactID
            : null
        }
        setIsAddEditContactDialogShown={setIsAddEditContactDialogShown}
        isAgent={myInfo.user.Level <= 0 ? true : false}
      />

      {isModalHistoryShown && (
        <ModalHistory
          onClose={() => {
            setSelectedWAID(null);
            setIsModalHistoryShown(false);
          }}
          ChatListID={selectedChatListID}
          detailchat="admin"
          GenerateNonPopUpFiles={GenerateNonPopUpFiles}
          WAID={selectedWAID}
        />
      )}

      {isModalTranscriptionShown && (
        <ModalTranscription
          recMessageID={selectedTranscription}
          onClose={() => setIsModalTranscriptionShown(false)}
        />
      )}

      {isQAFormDialogShown && (
        <NewWindow
          copyStyles
          features={{
            height: 550,
            width: width >= 1440 ? 1440 : 900,
          }}
          onUnload={() => setIsQAFormDialogShown(false)}
        >
          {isTelemarketing ? (
            <QAFormTSS
              appID={applicationDetails.appdetail[0].applicationid}
              appTypeID={applicationDetails.appdetail[0].applicationtypeid}
              setIsQAFormDialogShown={setIsQAFormDialogShown}
            />
          ) : (
            <QAForm setIsQAFormDialogShown={setIsQAFormDialogShown} />
          )}
        </NewWindow>
      )}

      <Dialog
        open={isImageOpen}
        className="dialog field-image-dialog"
        fullWidth
        scroll="paper"
        onClose={handleMapClose}
      >
        <div className="dialog-container">
          <div className="dialog-content">
            <IconButton className="close-button" onClick={handleMapClose}>
              <CloseOutlined />
            </IconButton>

            <img
              alt=""
              src={`${process.env.REACT_APP_FILE_SERVER_URL}/field-collection/${selectedImage}`}
            />
          </div>
        </div>
      </Dialog>

      {isNewChatOpen && (
        /* <NewChatCampaign
          agentID={myInfo.user.AgentID}
          isOpen={setIsNewChatOpen}
          assignmentData={{
            name: contactInfo[0][0].ContactName,
            number: selectedNumber,
            campaignAssignmentID: contactDetails.RecordID,
            campaignContactID: contactInfo[0][0].ContactID,
            campaignID: contactInfo[0][0].CampaignID,
            phoneTypeID: selectedPhoneTypeID,
          }}
        /> */

        <NewChat
          agentID={myInfo.user.AgentID}
          setOpenModal={setIsNewChatOpen}
          isSendingCallPermissionRequest={isSendingCallPermissionRequest}
          setIsSendingCallPermissionRequest={setIsSendingCallPermissionRequest}
          recipientPhoneNo={selectedNumber}
          isFromContactInformation
          contactID={
            isTelemarketing
              ? detailTSS.assignment.contactid
              : contactInfo[0][0].ContactID
          }
          campaignID={
            isTelemarketing
              ? detailTSS.assignment.campaignid
              : contactInfo[0][0].CampaignID
          }
          phoneTypeID={selectedPhoneTypeID}
          isTelemarketing={isTelemarketing}
          contactName={contactInfo[0][0].ContactName}
          sendMessage={sendMessage}
          assignmentID={contactDetails.RecordID}
          contactDetails={contactInfo[5][0]}
        />
      )}
    </div>
  );
}
